import { type ElementType } from 'react';
import { type SvgIconProps } from '@mui/material';

import {
  CursorIcon,
  ChargeIcon,
  ConsolidationFlowIcon,
  ExternalFlowIcon,
  DeliveryPositionIcon,
  FlowIcon,
  GoodsToPersonsIcon,
  HighwayIcon,
  IntakeIcon,
  LogicalSpaceIcon,
  ObstacleIcon,
  ParkingIcon,
  ProcessIcon,
  StackedLineChart,
  StoragePositionIcon,
  TemplateIcon,
  WallIcon,
  LinkIcon,
  HandIcon,
  OrbitIcon,
  RackingAreaIcon,
  ReadmoreIcon,
  ContactIcon,
} from '../../assets/icons';

export type IconComponent = ElementType<SvgIconProps>;

export const ICONS = {
  cursor: CursorIcon,
  pan: HandIcon,
  orbit: OrbitIcon,

  wall: WallIcon,
  obstacle: ObstacleIcon,
  logical_space: LogicalSpaceIcon,

  intake: IntakeIcon,
  storage: StoragePositionIcon,
  parking: ParkingIcon,
  charging: ChargeIcon,
  delivery: DeliveryPositionIcon,
  racking: RackingAreaIcon,

  process: ProcessIcon,
  manual: ProcessIcon,
  insertion: DeliveryPositionIcon,
  extraction: IntakeIcon,

  lassie: TemplateIcon,
  lassie_mini: TemplateIcon,
  shuttle: RackingAreaIcon,
  hik: TemplateIcon,

  highway: HighwayIcon,
  highway_angled: StackedLineChart,

  transport_flow: FlowIcon,
  consolidation_flow: ConsolidationFlowIcon,
  goods_to_persons_flow: GoodsToPersonsIcon,
  external_flow: ExternalFlowIcon,
  distcon: LinkIcon,

  readMore: ReadmoreIcon,
  contact: ContactIcon,
} as const satisfies Record<string, IconComponent>;

export type IconName = keyof typeof ICONS;
